import { AbsatzVorgabe } from '@/domain/controlling/entities';
import { maskitoParseNumber } from '@maskito/kit';
import { z } from 'zod';

export const updateTagebuchEinstellungenSchema = z.object({
  zielProduktivitaetUmsatz: z.string().refine(
    (value) => {
      const number = maskitoParseNumber(value ?? '', { decimalSeparator: ',' });
      return !isNaN(number);
    },
    {
      message: 'Bitte gib einen gültigen Wert ein',
    },
  ),
  zielProduktivitaetAbsatz: z
    .object({
      value: z.string(),
      unit: z.nativeEnum(AbsatzVorgabe),
    })
    .refine(
      (value) => {
        const number = maskitoParseNumber(value.value ?? '', {
          decimalSeparator: ',',
        });
        return !isNaN(number);
      },
      {
        message: 'Bitte gib einen gültigen Wert ein.',
      },
    ),
});
